import {SalesItem} from './SalesItem';

export class Print_report_obj {
  public printInvoice: SalesItem[] = [];
  public discount: number;
  public deliveryCharges: number;
  public subTotal: number;
  public totalTax: number;
  public total: number;
  public paid_amount: number;
  public credit_amount: number;
  public change_amount: number;
  public barCode: string;
  public customer_name: string;
  public invoice_number: string;
  public s_invoice_number: string;
  public sale_type: string;
  public email_invoice : boolean;
  public email_address : string;
}
